module.exports = "/static/media/icon-note.4bfb651a.svg";